<template>
  <div>
    <TopBar :page="topBarData"/>
    <v-container fluid>
      <v-row>
        <v-col>
          <NumberPool />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import NumberPool from '@/components/Admin/NumberPool';
import TopBar from "@/components/Layout/TopBar";

export default {
  components: {TopBar,NumberPool},
  data() {
    return {
      topBarData: {
        name: 'Number Pool Dashboard',
        type: 'numberPoolAdmin',
        showSearch: true,
        menu: false,
        breadcrumbs: [],
        additionalButtons: [],
        showBeehiveIcon: false,
      }
    }
  },
}
</script>

<style>

</style>
